import { ContentStackStore } from '../content-stack.store'
import { EntryStateNonSuccess, EntryStateSuccess } from '../types'

import { Entries } from '@/constants/content-stack'
import { FetchStatus } from '@/constants/general'

/**
 * Set entry state as success providing the entry result
 */
export function setEntryState(
  entryIdentifier: Entries[keyof Entries],
  status: FetchStatus.SUCCESS,
  entry: unknown,
): void

/**
 * Set entry state as error providing the error
 */
export function setEntryState(
  entryIdentifier: Entries[keyof Entries],
  status: FetchStatus.ERROR,
  errorPayload: unknown,
): void

/**
 * Set entry state as IDLE or fetching, do not need to provide a payload
 */
export function setEntryState(
  entryIdentifier: Entries[keyof Entries],
  status: Exclude<FetchStatus, FetchStatus.SUCCESS | FetchStatus.ERROR>,
): void
export function setEntryState(
  entryIdentifier: Entries[keyof Entries],
  status: FetchStatus,
  entryOrErrorPayload: unknown = undefined,
) {
  const entry = status === FetchStatus.SUCCESS ? entryOrErrorPayload : undefined
  const errorPayload =
    status === FetchStatus.ERROR ? entryOrErrorPayload : undefined

  ContentStackStore.setState(({ entries }) => ({
    entries: new Map(
      entries.set(entryIdentifier, {
        entry,
        errorPayload,
        status,
      } as EntryStateSuccess | EntryStateNonSuccess),
    ),
  }))
}
